import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });
const base = "/student-report-cards";

/** Published cards for the logged-in student */
export const getMyReportCards = async () => {
  const res = await axiosInstance.get(`${base}/my`);
  return res.data;
};

/** Detail + print payload (published only) */
export const getMyReportCardDetail = async (id) => {
  const res = await axiosInstance.get(`${base}/my/${id}`);
  return res.data;
};

/** HTML view URL (new tab — requires student session cookie) */
export const getMyReportCardHtmlUrl = (id) => `${API}${base}/my/${id}/html`;

/** PDF download URL */
export const getMyReportCardPdfUrl = (id) => `${API}${base}/my/${id}/pdf`;

/** Download PDF as Blob */
export const downloadMyReportCardPdf = async (id) => {
  const res = await axiosInstance.get(`${base}/my/${id}/pdf`, {
    responseType: "blob",
  });
  return res.data;
};
